




import { useState,useEffect } from 'react';
import { Copy, RefreshCw, Share2, Mail, Facebook, Twitter, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { io } from 'socket.io-client';

const CreateGroup = () => {
    const navigate = useNavigate();
    const [groupName, setGroupName] = useState('');
    const [groupCode, setGroupCode] = useState('');
    const [copied, setCopied] = useState(false);
    const [nameError, setNameError] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [groupLink, setGroupLink] = useState('');
    const [showShareIcons, setShowShareIcons] = useState(false);
    const [isGroupCreated, setIsGroupCreated] = useState(false);
    const [error, setError] = useState('');
    const [groups, setGroups] = useState([]);
    const [socket,setSocket] = useState(null);


  



 
    const fetchGroups = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/fetchgroups`);
            setGroups(response.data || []);
            console.log("res",response.data)
        } catch (error) {
            console.error('Error fetching groups:', error);
            setError('Failed to fetch groups. Please try again later.');
        }
    };

    useEffect(() => {
        fetchGroups();
    }, []);
    useEffect(() => {
        const socketUrl = 'https://backend.meracrackers.com';  
        console.log('Socket connecting...',socketUrl);
        const newSocket = io(socketUrl, {
          transports: ['websocket', 'polling'],
          reconnection: true,
          reconnectionAttempts: 5,
          reconnectionDelay: 1000,
          timeout: 10000,
        });
        newSocket.on('connect', () => {
          console.log(`Connected to server with socket id: ${newSocket.id}`);
          newSocket.emit('message', 'Hello from React Native!');
        });
      
        newSocket.on('connect_error', (error) => {
          console.error('Socket connection error details:', {
            message: error.message,
            description: error.description,
            context: error.context,
            type: error.type
          });  
        });
      
        newSocket.on('groupCreated', (data) => {
          console.log('groupCreated', data);
          fetchGroups();
        });
      
        newSocket.on('message', (data) => {
          console.log(`Message from server: ${data}`);
        });
      
        newSocket.on('disconnect', () => {
          console.log('Disconnected from server');
        });
      
        setSocket(newSocket);
      
        // Cleanup on unmount
        return () => {
          if (newSocket) {
            newSocket.disconnect();
          }
        };
      }, []);


const getCurrentUserId = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Unauthorized');
    }
    const response = await fetch(`${process.env.REACT_APP_URL}/api/user/getuser/${token}`)



    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("karis", data.customer_generated_id)
    return data.customer_generated_id;
}


const checkUserInGroups = (userId, groups) => {
    return groups.some(group => 
        group.groupmembers.some(member => 
            member.customer_generated_id === userId
        )
    );
};

    const generateGroupCode = () => {
        if (!groupName.trim()) {
            setNameError('Please enter a group name first');
            return;
        }
        setNameError('');

        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let code = '';
        for (let i = 0; i < 6; i++) {
            code += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        setGroupCode(code);
    };

    const handleBack = () => {
        navigate('/shop');
    };

    const goToGroup = () => {
        navigate(`/groups/${groupCode}`);
    };

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const handleGroupNameChange = (e) => {
        setGroupName(e.target.value);
        if (nameError) setNameError('');
    };

    const shareOnWhatsApp = (link) => {
        const url = `https://api.whatsapp.com/send?text=Check%20out%20this%20group%20link:%20${encodeURIComponent(link)}`;
        window.open(url, '_blank');
    };

    const shareViaEmail = (link) => {
        const subject = "Check out this group!";
        const body = `Here is the group link you requested: ${link}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    const shareOnTwitter = (link) => {
        const text = "Check out this group!";
        const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(link)}`;
        window.open(url, '_blank');
    };

    const shareOnFacebook = (link) => {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
        window.open(url, '_blank');
    };

    const createGroup = async () => {
        if (!groupName || !groupCode) return;
        setLoading(true);
        setError('');

        try {
            const userId = await getCurrentUserId();
            
            // Check if user is already in a group
            if (checkUserInGroups(userId, groups)) {
                setError('You are already a member of a group. You cannot create another group.');
                setLoading(false);
                return;
            }

            const token = localStorage.getItem('token');
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/creategroup`, {
                groupname: groupName,
                groupcode: groupCode
            }, {
                headers: {
                    'token': token
                }
            });
            localStorage.setItem('groupCode', groupCode);


            setSuccessMessage('Group created successfully!');
            const { groupcode } = response.data;
            const generatedLink = `https://app.meracrackers.com/groups/${groupcode}`;
            setGroupLink(generatedLink.startsWith("http") ? generatedLink : `https://${generatedLink}`);
            setIsGroupCreated(true);
        } catch (error) {
            console.error('Error creating group:', error);
            setError(error.response?.data?.message || 'Failed to create group. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white p-4 sm:p-8">
            <div className="max-w-2xl mx-auto">
                <h1 className="text-3xl font-bold text-center mb-8 text-orange-600">
                    Mera Crackers Group Ordering
                </h1>

                <div className="bg-white p-6 sm:p-8 rounded-xl shadow-lg space-y-6 relative">
                    <button
                        onClick={handleBack}
                        className="bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded-lg text-gray-600 hover:text-gray-800 flex items-center gap-2 group transition-all"
                    >
                        <span className="group-hover:-translate-x-1 transition-transform">←</span>
                        Back to options
                    </button>

                    <h2 className="text-2xl font-semibold text-gray-800">
                        Create New Group
                    </h2>

                    {error && (
                        <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                            {error}
                        </div>
                    )}

                    <div className="space-y-6">
                        <div className="space-y-2">
                            <label className="block text-gray-700 font-medium">
                                Group Name
                            </label>
                            <input
                                type="text"
                                value={groupName}
                                onChange={handleGroupNameChange}
                                className={`w-full p-3 border-2 ${nameError ? 'border-red-500' : 'border-gray-200'
                                    } rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors`}
                                placeholder="Enter your group name"
                            />
                            {nameError && (
                                <p className="text-sm text-red-500 mt-1">{nameError}</p>
                            )}
                        </div>

                        <div className="space-y-2">
                            <label className="block text-gray-700 font-medium">
                                Group Code
                            </label>
                            <div className="flex gap-2">
                                <input
                                    type="text"
                                    value={groupCode}
                                    readOnly
                                    className="flex-1 p-3 bg-gray-50 border-2 border-gray-200 rounded-lg font-mono"
                                    placeholder="Generate a group code"
                                />
                                <button
                                    onClick={generateGroupCode}
                                    className="p-3 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white rounded-lg flex items-center transition-all hover:shadow-md"
                                    title="Generate new code"
                                >
                                    <RefreshCw className="w-5 h-5" />
                                </button>
                                {groupCode && (
                                    <button
                                        onClick={() => copyToClipboard(groupCode)}
                                        className="p-3 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 text-gray-700 rounded-lg flex items-center transition-all"
                                        title="Copy code"
                                    >
                                        <Copy className="w-5 h-5" />
                                    </button>
                                )}
                            </div>
                        </div>

                        {successMessage && (
                            <p className="text-sm text-green-600 flex items-center gap-1">
                                <span className="inline-block w-2 h-2 bg-green-600 rounded-full"></span>
                                {successMessage}
                            </p>
                        )}

                        {groupLink && (
                            <div className="space-y-2">
                                <label className="block text-gray-700 font-medium">
                                    Shareable Group Link
                                </label>
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        value={groupLink}
                                        readOnly
                                        className="flex-1 p-3 bg-gray-50 border-2 border-gray-200 rounded-lg font-mono"
                                    />
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => copyToClipboard(groupLink)}
                                            className="p-3 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 text-gray-700 rounded-lg flex items-center transition-all"
                                            title="Copy link"
                                        >
                                            <Copy className="w-5 h-5" />
                                        </button>
                                        <button
                                            onClick={() => setShowShareIcons(!showShareIcons)}
                                            className="p-3 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 text-gray-700 rounded-lg flex items-center transition-all"
                                            title="Share"
                                        >
                                            <Share2 className="w-5 h-5" />
                                        </button>
                                        {showShareIcons && (
                                            <>
                                                <button
                                                    onClick={() => shareOnWhatsApp(groupLink)}
                                                    className="p-3 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-lg flex items-center transition-all"
                                                    title="Share on WhatsApp"
                                                >
                                                    <MessageCircle className="w-5 h-5" />
                                                </button>
                                                <button
                                                    onClick={() => shareOnTwitter(groupLink)}
                                                    className="p-3 bg-[#1DA1F2] hover:bg-[#1a91da] text-white rounded-lg flex items-center transition-all"
                                                    title="Share on Twitter"
                                                >
                                                    <Twitter className="w-5 h-5" />
                                                </button>
                                                <button
                                                    onClick={() => shareOnFacebook(groupLink)}
                                                    className="p-3 bg-[#1877F2] hover:bg-[#166fe5] text-white rounded-lg flex items-center transition-all"
                                                    title="Share on Facebook"
                                                >
                                                    <Facebook className="w-5 h-5" />
                                                </button>
                                                <button
                                                    onClick={() => shareViaEmail(groupLink)}
                                                    className="p-3 bg-[#EA4335] hover:bg-[#d33828] text-white rounded-lg flex items-center transition-all"
                                                    title="Share via Email"
                                                >
                                                    <Mail className="w-5 h-5" />
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <p className="text-sm text-gray-600 mt-2">
                                    Or click <a href={groupLink} target="_blank" rel="noopener noreferrer" className="text-orange-500 underline hover:text-orange-600">here</a> to visit the group.
                                </p>
                                {copied && (
                                    <p className="text-sm text-green-600 flex items-center gap-1">
                                        <span className="inline-block w-2 h-2 bg-green-600 rounded-full"></span>
                                        Link copied to clipboard!
                                    </p>
                                )}
                            </div>
                        )}

                        <button
                            onClick={isGroupCreated ? goToGroup : createGroup}
                            className={`w-full p-4 ${
                                isGroupCreated 
                                    ? 'bg-green-500 hover:bg-green-600 active:bg-green-700' 
                                    : 'bg-orange-500 hover:bg-orange-600 active:bg-orange-700'
                            } text-white rounded-lg font-medium transition-all hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed`}
                            disabled={(!groupName || !groupCode || loading) && !isGroupCreated}
                        >
                            {loading ? 'Creating...' : (isGroupCreated ? 'Go to Home' : 'Create Group')}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CreateGroup;


